import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import config from "config/config"
import i18n from "intl/i18n"

export default function usePageTitle() {
    const { t } = useTranslation()
    const isI18nInitialized = i18n.isInitialized
    const [pageTitle, setPageTitle] = useState<string>()

    useEffect(() => {
        if (!isI18nInitialized) return
        // such complex construction to prevent [] from displaying on production
        // because of build and env variables substitution process
        let prefix = `[${config.environmentSuffix}] `
        prefix = prefix === "[] " ? "" : prefix
        document.title = prefix
            ? `${prefix}${pageTitle || t('app.name')}`
            : t('app.name')
    }, [t, pageTitle, isI18nInitialized])

    return {
        pageTitle,
        setPageTitle
    }
}
